export const NotificationControllerFactory: INotificationControllerFactory = ({
  notificationService,
}) => {
  const getNotificationSetting: IGetNotificationSetting = async () => {
    const response = await notificationService.getNotificationSetting();
    return {
      success: response.success,
      data: response.data,
    };
  };

  const setNotificationSetting: ISetNotificationSetting = async (payload) => {
    const response = await notificationService.setNotificationSetting(payload);

    return {
      success: true,
      data: response.data,
    };
  };

  return {
    getNotificationSetting,
    setNotificationSetting,
  };
};
